/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IExampleParent } from '../../core/models/common/IExampleParent';
import { IExamplesParent } from '../../core/models/common/IExamplesParent';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to set the Example for a 3.0 MediaType or a 2.0 Response.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class SetExampleCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _newExample : any;

    public _oldValue : any;

    public constructor(parent? : any, example? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((example != null) || example === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._newExample = example;
            })();
        } else if(parent === undefined && example === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }
}
SetExampleCommand["__class"] = "io.apicurio.datamodels.cmd.commands.SetExampleCommand";
SetExampleCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




